<script setup lang="ts">
defineProps<{
  title?: string
  filters: Array<{
    name: string
    legend: string
    enabled: Set<string>
    options: ReadonlyArray<{ title: string, tagName: string, value: string }>
  }>
}>()
</script>

<template>
  <section class="relative flex flex-col gap-4 has-[svg]:mb-8 md:gap-12 has-[svg]:md:mb-28">
    <h2
      v-if="title"
      class="text-center font-headline text-xl leading-[175%]! font-normal md:text-3xl"
      v-text="title"
    />

    <form class="md:flex md:justify-between">
      <!-- mobile -->
      <details
        v-for="{ legend, ...filter } in filters"
        :key="filter.name"
        class="mx-auto my-4 w-full border-b border-[var(--accent-color,var(--color-green-20))] pb-4 text-white md:hidden"
      >
        <summary class="relative flex w-full cursor-pointer list-none items-center justify-between text-[var(--filter-color,var(--color-seagreen-50))] max-sm:text-xs">
          {{ legend }}
        </summary>
        <UiFilterCheckbox
          v-bind="filter"
          size="lg"
          :ui="{
            fieldset: 'mt-5 mr-auto mb-8 ml-2',
          }"
        />
      </details>

      <!-- desktop -->
      <UiFilterCheckbox
        v-for="filter in filters"
        :key="filter.name"
        v-bind="filter"
        class="hidden md:block"
        :ui="{
          root: '[--padding-inline:3rem] not-last-of-type:border-r flex-1 border-green-20 not-last-of-type:pr-[var(--padding-inline)] not-first-of-type:pl-[var(--padding-inline)]',
          fieldset: ['grid grid-flow-col grid-rows-3'],
        }"
      />
    </form>

    <UiFilterReset />

    <IconsArrowsDownLong class="absolute inset-x-0 top-auto -bottom-20 mx-auto hidden fill-coral-pop md:block" />
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

details {
  summary {
    letter-spacing: 0.0625rem;

    &::-webkit-details-marker {
      @apply hidden;
    }

    &::after {
      @apply rounded-full size-6 mr-2 leading-none text-2xl grid place-content-center content-['+'] border-[var(--filter-color,var(--color-seagreen-50))] border-[1.5px];
    }
  }

  &[open] summary::after {
    @apply content-['-'];
  }
}
</style>
